;(function() {
  'use strict'

  imageViewerService.$inject = ["$animate", "$compile", "$rootElement", "$rootScope", "$window"];
  angular
    .module('core.imageViewer')
    .service('imageViewerService', imageViewerService)

  /* @ngInject */
  function imageViewerService(
    $animate,
    $compile,
    $rootElement,
    $rootScope,
    $window
  ) {
    var WINDOW_PADDING = 20
    var MOBILE_MIN_WIDTH = 500

    var modalElem
    var imageElem
    var img

    var template =
      '<div class="image-modal" ng-click="close()"><img class="image" ng-src={{data.src}}></div>'

    var service = {
      show: show,
    }
    return service

    function show(src, origElement) {
      var animationActive = false

      // initialise
      init()

      /**
       * initialise image viewer modal
       */
      function init() {
        loadImage(src)
        angular.element($window).on('resize', _.debounce(onWindowResize, 200))
      }

      /**
       * resize the image to new window size
       */
      function onWindowResize() {
        $rootScope.$evalAsync(function() {
          $animate
            .animate(imageElem, {}, getFinalDims(), 'animate')
            .then(onOpen)

          function onOpen() {
            animationActive = false
          }
        })
      }

      /**
       * load the required image so we can get the dimensions
       */
      function loadImage() {
        img = new Image()
        img.onload = onImageLoaded()
        img.src = src
      }

      /**
       * image laoded
       */
      function onImageLoaded() {
        showModal()
      }

      /**
       * display image viewer modal - compile against new scope and append to DOM
       */
      function showModal() {
        // element to add modal window to - if cannot find body, use the app's root element
        var parent = $rootElement.find('body')
        if (!parent.length) {
          parent = $rootElement
        }

        // create new scope and attatch image source and close method
        var scope = $rootScope.$new()
        scope.data = {}
        scope.data.src = src
        scope.close = closeModal

        modalElem = $compile(template)(scope)
        imageElem = angular.element(
          modalElem[0].getElementsByClassName('image')
        )

        // add modalElem to DOM
        parent.append(modalElem)

        openModal()
      }

      /**
       * close image view modal, once animation is complete remove element from DOM
       */
      function closeModal() {
        if (animationActive) {
          return
        }

        animationActive = true
        $animate.removeClass(modalElem, 'active')
        $rootScope.$evalAsync(function() {
          $animate
            .animate(imageElem, getFinalDims(), getStartDims(), 'animate')
            .then(onClosed)

          function onClosed() {
            animationActive = false
            modalElem.remove()
          }
        })
      }

      /**
       * animate opening modal window and image
       */
      function openModal() {
        animationActive = true
        $animate.addClass(modalElem, 'active')
        $rootScope.$evalAsync(function() {
          $animate
            .animate(imageElem, getStartDims(), getFinalDims(), 'animate')
            .then(onOpen)

          function onOpen() {
            animationActive = false
          }
        })
      }

      /**
       * get starting dimentions for the image
       * @return {Object} object containing top, left, height and width properties of image
       */
      function getStartDims() {
        var rect = origElement[0].getBoundingClientRect()

        return {
          top: rect.top + 'px',
          left: rect.left + 'px',
          height: origElement[0].clientHeight + 'px',
          width: origElement[0].clientWidth + 'px',
        }
      }

      /**
       * get final dimentions for the image based on the current window size
       * @return {Object} object containing top, left, height and width properties of image
       */
      function getFinalDims() {
        var top
        var left
        var width
        var height
        var maxWidth
        var maxHeight
        var imgWidth = img.width
        var imgHeight = img.height
        var winWidth = modalElem[0].clientWidth
        var winHeight = modalElem[0].clientHeight

        if (modalElem[0].clientWidth < MOBILE_MIN_WIDTH) {
          // no padding on mobile
          maxWidth = modalElem[0].clientWidth
          maxHeight = modalElem[0].clientHeight
        } else {
          maxWidth = modalElem[0].clientWidth - WINDOW_PADDING * 2
          maxHeight = modalElem[0].clientHeight - WINDOW_PADDING * 2
        }

        var widthScaler = imgWidth / imgHeight
        var heightScaler = imgHeight / imgWidth

        // portrait
        if (imgHeight > imgWidth) {
          height = imgHeight > maxHeight ? maxHeight : imgHeight
          width = height * widthScaler

          // landscape / square
        } else {
          width = imgWidth > maxWidth ? maxWidth : imgWidth
          height = width * heightScaler
        }

        // check over-height
        if (height > maxHeight) {
          height = maxHeight
          width = height * widthScaler
        }

        // check over-width
        if (width > maxWidth) {
          width = maxWidth
          height = width * heightScaler
        }

        // position
        top = (winHeight - height) / 2
        left = (winWidth - width) / 2

        return {
          top: top + 'px',
          left: left + 'px',
          width: width + 'px',
          height: height + 'px',
        }
      }
    }
  }
})()
